import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import Utils from '../utils.js';

export default class NodeDelete extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);
		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{ 
		return 'delete';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pGeoList = inputValues['geo'];
		if(!pGeoList || !Array.isArray(pGeoList))
			return null;

		let pResList = [];
		for(let pSrcMesh of pGeoList)
		{
			if(!pSrcMesh)
				continue;

			if(!Utils.getIsMeshObject(pSrcMesh))
			{
				pResList.push(pSrcMesh);
				continue;
			}

			pSrcMesh.dispose();
		}

		return pResList;
	}
}